import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import classnames from 'classnames';
import moment from 'moment';
import 'moment/locale/fr';
import {getFirstLastDateSession} from '../../../Events/helpers';
import {truncateText} from '../../../../app/utils/text';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import UndoIcon from '@material-ui/icons/Undo';
import EditIcon from '@material-ui/icons/Edit';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_events';

const styles = theme => ({
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 16,
    },
});

class DashboardEventsListItem extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    handleClickUnsubscribe = (e) => {
        e.preventDefault();

        const {event} = this.props;

        this.props.handleClickUnsubscribe(event);
    };

    handleClickUpdate = (e) => {
        e.preventDefault();

        const {event} = this.props;

        this.props.handleClickUpdate(event);
    };

    render() {
        const {event, classes} = this.props;

        moment.locale('fr');

        const url = this.props.translate('routes.events_details').replace(':slug', event.slug);

        let typeName = '';

        if (Array.isArray(event.types) && event.types.length > 0) {
            // Copy the array (not a reference) => mandatory because we call shift() and that the render() function may be called more than once...
            let copyTypes = event.types.slice(0);
            let type = copyTypes.shift();
            typeName = type.name;
        }

        const dateFormat = 'D MMM YYYY à HH:mm';
        // let datesStr = moment(event.currentUserCheckinDetails.date_event, 'YYYY-MM-DD hh:mm:ss').format(dateFormat);
        // let dates = getFirstLastDateSession(event.dates);

        // if (dates.length === 1) {

        // }
        /*else if (dates.length === 2) {
            if (dates[0].date && dates[1].date) {
                let dateTime1 = dates[0].date;
                let dateTime2 = dates[1].date;

                datesStr = moment(dateTime1, 'YYYY-MM-DD').format(dateFormat);
                datesStr += '<br />';
                datesStr += moment(dateTime2, 'YYYY-MM-DD').format(dateFormat);
            }
        }*/

        let openCheckin = true;
        const nowDatetime = moment().format('YYYY-MM-DD');

        if (event.first_date_from_today !== '') {
            const checkinDeadlineDate = moment(event.first_date_from_today, 'YYYY-MM-DD').subtract(event.checkin_deadline, 'days');
            const checkinDeadlineDatetime = checkinDeadlineDate.format('YYYY-MM-DD');
            if (nowDatetime > checkinDeadlineDatetime) {
                openCheckin = false;
            }
        } else {
            openCheckin = false;
        }

        return (
            <div className="col-lg-3 col-md-6 col-sm-12" key={event.id}>
                <div className="item item-dashboard">
                    <div className="inner">
                        <div className="top">
                            {typeName !== '' &&
                                <div className="category">
                                    {typeName}
                                </div>
                            }
                            <div>
                                {ReactHtmlParser(moment(event.currentUserCheckinDetails.date_event, 'YYYY-MM-DD hh:mm:ss').format(dateFormat))}
                            </div>
                            <div>
                                Degrés scolaires: {event.currentUserCheckinDetails.degrees.join(', ')}
                            </div>
                            <div>
                                Nombre d'élèves attendus: {event.currentUserCheckinDetails.number_students_expected}
                            </div>
                        </div>
                        <div className="title">
                            <Link to={url}>
                                {ReactHtmlParser(truncateText(event.title, 70))}
                            </Link>
                        </div>
                        <div className="bottom">
                            <Fragment>
                                {openCheckin ? (
                                    <Fragment>
                                        <Button variant="contained" size="small" color="primary" className="btn btn-register" onClick={this.handleClickUnsubscribe}>
                                            <UndoIcon className={classnames(classes.leftIcon, classes.iconSmall)} />
                                            <Translate id="dashboard_events.buttun_unsubscribe" />
                                        </Button>
                                        <Button variant="contained" size="small" color="primary" className="btn btn-update" onClick={this.handleClickUpdate}>
                                            <EditIcon className={classnames(classes.leftIcon, classes.iconSmall)} />
                                            <Translate id="dashboard_events.buttun_update" />
                                        </Button>
                                    </Fragment>
                                ) : (
                                    <Tooltip title={this.props.translate('dashboard_events.notice_unsubscribe_too_late')}>
                                        <span>
                                            <Button variant="contained" size="small" color="primary" className="btn btn-register" disabled={true}>
                                                <UndoIcon className={classnames(classes.leftIcon, classes.iconSmall)} />
                                                <Translate id="dashboard_events.buttun_unsubscribe" />
                                            </Button>
                                        </span>
                                    </Tooltip>
                                )}
                            </Fragment>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DashboardEventsListItem.propTypes = {
    classes: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    handleClickUnsubscribe: PropTypes.func.isRequired,
    handleClickUpdate: PropTypes.func.isRequired,
};

export default withStyles(styles)(withLocalize(DashboardEventsListItem));


// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Events/DashboardEventsListItem.js